var _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleGeneratorOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 24.0882,
    height: 2.2,
    rx: 1.1,
    fill: "#26BFC9",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.0882,
    height: 2.2,
    rx: 1.1,
    fill: "#26BFC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 24.0882,
    height: 2.2,
    rx: 1.1,
    fill: "#26BFC9",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 17.0625,
    height: 2.2,
    rx: 1.1,
    fill: "#26BFC9",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGeneratorOutline);
export default __webpack_public_path__ + "static/media/title_generator_outline.17c3e00e46f3d92ef4eb3c9a34e6cbef.svg";
export { ForwardRef as ReactComponent };